import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractPeriodReportEvent from "./AbstractPeriodReportEvent.js";

/**
 * A `CreateEvent` is logged when a new period report draft is started by an accountant.
 * There is only one such event in a period report event log and it can only be the first event.
 */
export default class CreateEvent extends AbstractPeriodReportEvent {
	isStatusEvent() {
		return true;
	}

	isCreate() {
		return true;
	}

	getLabel() {
		return _("Created");
	}

	static getType() {
		return "Create";
	}
}
